import styled from 'styled-components';
import { InvertibleButton } from 'src/components/Button/InvertibleButton';

interface IStyledSimpleButtonProps {
  useSmallTextSize?: boolean;
}

const baseFontSize = ({ useSmallTextSize }: IStyledSimpleButtonProps) => useSmallTextSize ? 16 : 16;

export const StyledSimpleContainer = styled.div`
  font-size: ${baseFontSize}px;
  padding: 0;
`;

export const StyledSimpleButton = styled(InvertibleButton)`
  box-sizing: border-box;
  ${({ theme: { fullWidth }}) => fullWidth ? 'width: 100%;' : ''};
  display: flex;
  gap: .75rem;
  align-items: center;
  font-family: var(--font-family);
  font-size: inherit;
  line-height: 1.25;
  text-align: center;
  cursor: pointer;
  border-radius: .5rem;
  padding: 0.5rem 0.75rem;
  transition: all 200ms ease;
  border: 1.5px solid currentColor;
  text-align: left;

  .logo {
    display: flex;

    svg {
      height: 1.5em;
    }
  }

  .prompt {
    flex-grow: 1;
  }

  .price {
    font-weight: 700;
    margin: 0 0 0 0.33em;
  }

  @media (max-width: 200px) {
    font-size: 14px;
    text-align: left;
  }

  @media (max-width: 120px) {
    font-size: 12px;
    text-align: left;
    padding: 0.5625rem 0.5rem;
    gap: .5rem;
  }
`;
